/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Default mount point name
 */
export const LAYOUT_MOUNT_POINT = 'renderPage';

/**
 * Default Proxy Address
 */
export const DEFAULT_PROXY_HOST = 'http://127.0.0.1';

/**
 * Default Proxy Port
 */
export const DEFAULT_PROXY_PORT = 8888;

/**
 * Default request timeout in ms (1m default);
 */
export const DEFAULT_REQUEST_TIMEOUT: number = parseInt(process.env.REQUEST_TIMEOUT || '60000', 10);

export const GLIMPSE_LOGGER_NAME = '__INTERNAL_GLIPMPSE_LOGGER_!@';
export const PAGE_LOGGER_NAME = '__PAGE_LOGGER__';

/**
 * appCacheSetting Name
 */

export const CACHE_SETTING = '__CACHE_SETTINGS';

/**
 * const for client entry points type
 */
export const CLIENT_ENTRY_POINTS_TYPE = '__CEP__';

/**
 * PDP PageType Name
 */
export const PDP_PAGE_NAME = 'product';

/**
 * Product recommendtion list
 */
export const PRODUCT_RECOMMENDATION_LIST = 'pal';

/**
 * Frequently bought together recommendation list
 */
export const FREQUENTLY_BOUGHT_TOGETHER_LIST = 'fbt';

/**
 * Picks for you recommendation list
 */
export const PICKS_FOR_YOU_LIST = 'picks';

/**
 * Category PageType Name
 */
export const CATEGORY_PAGE_NAME = 'category';

/**
 * List PageType Name
 */
export const LIST_PAGE_NAME = 'list';

/*
 * Cache key for module
 */
export const MODULE_CACHE_KEY: string = '__M';

/**
 * Cache key for module config
 */
export const MODULE_CONFIG_KEY: string = '__MC';

/**
 * Cache key for module disabled properties
 */
export const MSDYN365_WYSIWYG_DISABLED_PROPS = '__MDP';

/**
 * Cache key for module disabled properties
 */
export const MSDYN365_WYSIWYG_CANADDMODULE = '__MCA';

/**
 * Cache key for module config errors
 */
export const MODULE_CONFIG_ERRORS_KEY: string = '__MCE';

/**
 * Cache key for module data
 */
export const MODULE_DATA_KEY: string = '__MD';

/**
 * Cache key for module resources
 */
export const MODULE_RESOURCES_KEY: string = '__MR';

/**
 * Cache key for module action
 */
export const MODULE_ACTION_KEY: string = '__MA';

/**
 * Cache key for module deferred render
 */
export const MODULE_DEFERRED_KEY: string = '__MDR';

/**
 * Cache key for module view cache
 */
export const MODULE_VIEW_CACHE_KEY = '__VIEWCACHEKEY__';

/**
 * Cache key for module render to string result
 */
export const MODULE_RENDER_RESULT_CACHE_KEY = '__MODULE_RENDER_RESULT__';

/**
 * Server Render Error Cache key type
 */
export const SERVER_RENDER_ERROR_CACHE_KEY = '__SERVER_RENDER_ERROR__';

/**
 * Cache key for page render results
 */
export const PAGE_RENDER_RESULT_CACHE_KEY = '__PAGE_RENDER_RESULT__';

/**
 * The Prefix for the module lazyload feature switch
 */
export const LAZYLOAD_SWITCH_PREFIX = 'lazyload_';

/**
 * DEPRECATED Client Render Complete Event Name
 */
export const DEPRECATED_CLIENT_RENDER_COMPLETE_EVENT = '_msdyn365_client_render_complete';

/**
 *  Client Data Update Event Name
 */
export const CLIENT_DATA_UPDATE_EVENT = '_msdyn365_client_data_update';

/**
 * Client Render Complete Event Name
 */
export const CLIENT_RENDER_START_EVENT = '_msdyn365_client_render_start';

/**
 * Client Render Complete Event Name
 */
export const CLIENT_RENDER_COMPLETE_EVENT = '_msdyn365_client_render_complete';

/**
 * Event that fires when Authoring module or fragment add operation completes rendering
 */
export const AUTHORING_ADD_RENDER_COMPLETE_EVENT = '_msdyn365_authoring_add_render_complete';

/**
 * User Consent Given Event Name
 */
export const USER_CONSENT_GIVEN_EVENT = '_msdyn365_user_consent_given';

/**
 * Field name of the module layout that authoring sends
 */
export const MODULE_LAYOUT_FIELD = 'msdyn365__moduleLayout';

/**
 * Process type enum
 */
export const enum PROCESS_TYPE {
    server = 'server',
    client = 'client'
}
/**
 * The retail server base URL request header key.
 */
export const RETAIL_SERVER_BASE_URL_HEADER_KEY = `x-rs-base-url`;
/**
 * Error message for when the provider get experiments function fails.
 */
export const PROVIDER_GET_EXPERIMENTS_FAIL = 'Provider get experiments call failed. Retail Server Base URL: "{retailServerBaseUrl}"';

/**
 * Error message for when the retail server api call fail.
 */
export const GET_FEATURE_STATES_API_CALL_FAIL = 'The retail server getFeatureStatesAsync API call failed.';

/**
 * Error message for when the internal get feature states data action fail.
 */
export const GET_FEATURE_STATES_INTERNAL_DATA_ACTION_FAIL = 'The internal get feature states data action failed.';

/**
 * Error message for when the internal get feature states data action fail.
 */
export const ERROR_PROCESSING_APP_SETTINGS = 'Error processing application settings.';

/**
 * Error message for missing required chunks
 */
export const ERROR_MISSING_REQUIRED_CHUNKS = `Failed to get required chunks for module '{moduleId}' of type '{moduleType}'. List of missing chunks: '{listOfMissingChunks}'`;

/**
 * The feature states.
 */
export const FEATURE_STATE = {
    ON: 'ON',
    OFF: 'OFF'
};

/**
 * Application settings configs feature management properties.
 */
export const APP_SETTINGS_CONFIG_PROPS = {
    DISABLED_WITH_FEATURE_FLAGS: 'disabledWithFeatureFlags',
    HIDDEN_WITH_FEATURE_FLAGS: 'hiddenWithFeatureFlags',
    DISABLED: 'disabled',
    HIDDEN: 'hidden'
};

/**
 * Cache type name for module css chunks
 */
export const MODULE_CSS_CACHE_TYPENAME = '__ModuleCssChunks__';

/**
 * Cache key name for module css chunks
 */
export const MODULE_CSS_CACHE_KEY = 'module-css-chunks';

/**
 * Cache key name for module css chunks
 */
export const INLINE_MODULE_CSS_CACHE_KEY = 'inline-module-css-chunks';
